import { ApiRequest } from "src/helpers";
import { API_END_POINTS } from "src/constants";

export function getLeads() {
  return ApiRequest.fetchAdmin({
    method: "get",
    url: `${API_END_POINTS.LEADS}`,
  }).then((response) => response.data.leads);
}